module.exports = __webpack_public_path__ + "img/expand-01.c1c2f903.svg";